module.exports = __webpack_public_path__ + "static/stripes-left-044ed34d57ca975c70bf64b54e885fab.svg";